import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ExternalLink, BookOpen, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from "@/components/ui/use-toast";

const BlogRedirectPage = () => {
  const { toast } = useToast();

  const handleRedirect = () => {
    toast({
      title: "Thanks for your interest!",
      description: "The blog isn't live yet — check back soon, or follow our WhatsApp/Instagram for updates.",
    });
  };

  return (
    <>
      <Helmet>
        <title>Physics Blog - PhysicsNotebook.in | Latest Articles & Tips</title>
        <meta name="description" content="Explore our physics blog with latest articles, study tips, exam strategies, and insights for JEE, NEET, and board exam preparation." />
      </Helmet>

      <section className="min-h-screen hero-gradient flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <div className="flex justify-center">
              <div className="bg-gradient-to-r from-[#123B7A] to-[#0EA5FF] w-24 h-24 rounded-full flex items-center justify-center">
                <BookOpen className="h-12 w-12 text-white" />
              </div>
            </div>

            <h1 className="font-display text-4xl md:text-6xl font-semibold text-gray-900 mb-6">
              The <span className="gradient-text">Physics Blog</span> Is on Its Way
            </h1>

            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Study tips, exam strategies, and physics insights for Boards, JEE, and NEET — written by the same mentors behind Physics Notebook.
            </p>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto">
              <div className="flex items-center justify-center mb-4">
                <ExternalLink className="h-8 w-8 text-[#123B7A] mr-3" />
                <h2 className="text-2xl font-semibold text-gray-900">Coming Soon</h2>
              </div>
              <p className="text-gray-600 mb-6">
                We're building <strong>blog.physicsnotebook.in</strong> properly rather than rushing it out. Leave your name and we'll let you know the moment it's live.
              </p>
              
              <Button 
                onClick={handleRedirect}
                className="btn-primary text-white px-8 py-3 text-lg w-full sm:w-auto"
              >
                Notify Me When It's Ready
                <ArrowRight className="h-5 w-5 ml-2" />
              </Button>
            </div>

            <div className="pt-8 border-t border-gray-200">
              <p className="text-gray-500 text-sm mb-4">
                In the meantime, you can explore other parts of our site:
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/" className="text-[#123B7A] hover:text-blue-800 underline">
                  Return to Homepage
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default BlogRedirectPage;
